{
  "sidenavMenuCloseTooltip": "关闭菜单",
  "sidenavMenuLockTooltip": "单击以锁定菜单",
  "toggleSideNav": "切换侧面导航菜单"
}
